<script>
	import _ from 'lodash'
	import FilterGroup from './filter-group'
	import draggable from 'vuedraggable'

	export default {
		components: {
			'nk-filter-group': FilterGroup,
			'draggable': draggable
		},
		props: {
			scheme: { type: Object },
			modelValue: { type: Array },
			addGroupButtonVisible: { type: Boolean, default: true }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				filterGroups: [],
				counter: 1,
				drag: false
			}
		},
		computed: {
		},
		watch: {
			modelValue: {
				immediate: true,
				deep: true,
				handler(val) {
					if (!_.isEqual(this.filterGroups, val)) {
						this.filterGroups = _.cloneDeep(val) || []
					}
				}
			}
		},
		created() {

		},
		mounted() {
			this.addGroup()
		},
		methods: {
			addGroup() {
				let item = { id: this.counter++, items: [], operator: 'and' }
				this.filterGroups.push(item)
			},
			findFilterGroupIndex(item) {
				let index = this.filterGroups.findIndex(x => x.id === item.id)
				return index
			},
			filterGroupRowChanged(val, deletedValue) {
				if (!val) {
					if (deletedValue) {
						let index = this.findFilterGroupIndex(deletedValue)
						if (index > -1) {
							this.filterGroups.splice(index, 1)
						}
					}

					this.localValueChanged()
					return
				}

				let index = this.findFilterGroupIndex(val)
				if (index > -1) {
					this.filterGroups.splice(index, 1, val)
				} else {
					this.filterGroups.push(val)
				}

				this.localValueChanged()
			},
			dragEnded() {
				this.drag = false
			},
			localValueChanged() {
				this.$emit('update:modelValue', _.cloneDeep(this.filterGroups))
			},
			removeGroup(item, index) {
				this.filterGroups.splice(index, 1)
				this.localValueChanged()
			},
			operatorChanged() {
				this.localValueChanged()
			}
		}
	}
</script>
<template>
	<div>
		<ul class="filter-collection">
			<draggable v-model="filterGroups" group="filterGroups" @start="drag = true" @end="dragEnded" handle=".group-drag-handler">
				<li v-for="(item, index) in filterGroups" :key="item.id">
					<div class="group-buttons">
						<a class="btn btn-sm btn-link group-drag-handler">
							<icon icon="bars" />
						</a>
						<button type="button" class="btn btn-sm btn-dark" @click.stop="removeGroup(item, index)">
							<icon icon="trash" />
						</button>
						<div class="d-inline-block operator-col">
							<select v-model="item.operator" :disabled="index === 0 ? true : null" class="form-control form-control-sm" @change="operatorChanged">
								<option value="and">و</option>
								<option value="or">یا</option>
							</select>
						</div>
					</div>
					<nk-filter-group :scheme="scheme" :modelValue="item" :operatorVisible="index > 0" :removeButtonVisible="true" @update:modelValue="filterGroupRowChanged"></nk-filter-group>
				</li>
			</draggable>
			<li v-if="addGroupButtonVisible">
				<div class="row no-gutters">
					<div class="col-12 col-md group-plus-button-col">
						<button class="btn btn-sm btn-block btn-dark" type="button" @click.stop="addGroup">
							<icon icon="plus" />
						</button>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>
<style>
	.filter-collection {
		padding: 0;
		margin: 0;
		list-style: none;
	}

	.filter-collection>div>li {
		padding: 5px;
	}

	.filter-collection>div>li .group-buttons {
		padding-right: 5px;
	}

	.filter-collection>div>li .group-buttons button {
		margin-right: 4px;
	}

	@media (min-width: 768px) {
		.group-plus-button-col {
			margin-right: 20px;
			max-width: 90px;
		}
	}
</style>
